/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Vendor_Returns_To_ConfirmInputs */

const en_queue_vendor_returns_to_confirm = /** @type {(inputs: Queue_Vendor_Returns_To_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendor returns the supplier has to confirm`)
};

/**
* | output |
* | --- |
* | "Vendor returns the supplier has to confirm" |
*
* @param {Queue_Vendor_Returns_To_ConfirmInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_vendor_returns_to_confirm = /** @type {((inputs?: Queue_Vendor_Returns_To_ConfirmInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Vendor_Returns_To_ConfirmInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_vendor_returns_to_confirm(inputs)
});